<div class="progress">
  <div class="progress__status" *ngIf="showPercentProgress">{{ getProgressInPercent() }} %</div>
  <div class="progress__bar-container">
    <div class="progress__bar" [style]="'width:'+getProgressInPercent()+'%'"></div>
  </div>
  <div class="progress__additional-text" *ngIf="message">{{ message }}</div>
</div>
